module.exports = __webpack_public_path__ + "static/media/systems.c9840797.svg";